import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import CustomSelect from 'components/atoms/dropdowns/custom-select';
import SwitchFrame from './switch-frame';
import {generateRandomKey} from 'helpers/hash';

function getOption(value) {
    return {value, label: value};
}

class GameSwitch extends Component {
    onChange(selected) {
        const value = selected?.value ?? '';
        this.props.dispatch(Action.set('GameTypeFilter', value));
    }

    renderOption(item) {
        return <SwitchFrame value={item.value} />;
    }

    render() {
        const {sportConfig} = this.props;
        const gameTypes = sportConfig.getGameTypes();

        if (isEmpty(gameTypes)) {
            return null;
        }

        const options = Object.keys(gameTypes).map((type) => getOption(type));
        const type = sportConfig.getGameType();
        const value = type ? getOption(type) : '';

        return (
            <div className="type-cell" data-testid="game-type-dropdown">
                <label className="label-alt">Game type</label>
                <CustomSelect
                    key={generateRandomKey()}
                    defaultValue={value}
                    options={options}
                    value={value}
                    renderOption={::this.renderOption}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(GameSwitch);
